import { useEffect, useState } from "react";
import { Plane } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUS_OPTIONS = ["nouvelle", "en_traitement", "devis_envoye", "cloturee"];
const STATUS_LABEL = { nouvelle: "Nouvelle", en_traitement: "En traitement", devis_envoye: "Devis envoyé", cloturee: "Clôturée" };
const STATUS_CLS = {
  nouvelle: "bg-blue-100 text-blue-700",
  en_traitement: "bg-amber-100 text-amber-700",
  devis_envoye: "bg-purple-100 text-purple-700",
  cloturee: "bg-green-100 text-green-700",
};

export default function FlightQuotesAdmin() {
  const [quotes, setQuotes] = useState([]);

  const load = () => api.get("/admin/flight-quotes").then(({ data }) => setQuotes(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (q, status) => {
    await api.patch(`/admin/flight-quotes/${q.id}`, { status }).catch(() => {});
    toast.success("Statut mis à jour");
    load();
  };

  return (
    <div>
      <h2 className="font-head text-2xl font-extrabold text-primary mb-4">Demandes de devis vol</h2>
      <div className="space-y-3">
        {quotes.length === 0 && <p className="text-muted-foreground text-sm">Aucune demande.</p>}
        {quotes.map((q) => (
          <div key={q.id} className="bg-white rounded-2xl soft-shadow border border-gray-100 p-4" data-testid={`flight-quote-${q.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <Plane className="h-4 w-4 text-accent" />
                  <span className="font-semibold text-primary">{q.departure} → {q.destination}</span>
                  <span className={`text-xs font-bold px-3 py-1 rounded-full ${STATUS_CLS[q.status] || "bg-gray-100"}`}>{STATUS_LABEL[q.status] || q.status}</span>
                </div>
                <p className="text-sm text-muted-foreground">
                  Départ : {new Date(q.depart_date).toLocaleDateString("fr-FR")}
                  {q.return_date ? ` · Retour : ${new Date(q.return_date).toLocaleDateString("fr-FR")}` : ""} · {q.passengers} passager(s)
                </p>
                <p className="text-sm text-muted-foreground">Contact : {q.contact_name} — {q.contact_phone}</p>
              </div>
              <select value={q.status} onChange={(e) => setStatus(q, e.target.value)} className="h-10 rounded-xl border border-input px-3 bg-white text-sm" data-testid={`flight-status-${q.id}`}>
                {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{STATUS_LABEL[s]}</option>)}
              </select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
